module.exports = ".slider-container {\n  width: 100%;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  background: white; }\n  .slider-container .slider {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/visualizer/color-groups/color-groups.component.scss
// module id = ./src/app/components/visualizer/color-groups/color-groups.component.scss
// module chunks = main